module.exports = __webpack_public_path__ + "static/img/liu2.690671e.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/liu2.png
// module id = FDjS
// module chunks = 3